import {Component, OnInit, ViewChild} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {LangChange} from '../../../../../lang-change';
import {Language} from '../../../../../common/models/language';
import {PageDTO} from '../../../../../common/dtos/PageDTO';
import {PaginationComponent} from '../../../../shared/components/pagination/pagination.component';
import {CenterNationalityService} from '../../../services/center-nationality.service';
import {CenterNationality} from './center-nationality';
import {CenterNationalityDialogComponent} from './edit/center-nationality-dialog.component';
import {MatDialog} from '@angular/material';
import {Utils} from '../../../../../common/services/Utils';
import {Principal} from '../../../../../common/services/principal';
import {ModuleExtendedEdit} from '../../../../../common/enums/module-extended-edit.enum';
import {ModuleENUM} from '../../../../../common/enums/module.enum';

@Component({
  selector: 'app-center-nationality',
  templateUrl: './center-nationality.component.html',
  styleUrls: ['./center-nationality.component.scss']
})
export class CenterNationalityComponent extends LangChange implements OnInit {

  page: PageDTO;
  centerNationalityList: CenterNationality[];
  hasWriteAccess = false;
  isAdmin = false;

  constructor(private _dialog: MatDialog,
              private _principal: Principal,
              private _utils: Utils,
              private _centerNationalityService: CenterNationalityService) {
    super(_utils._translateService);
    this.isAdmin = _principal.isAdmin() || _principal.isRegionAdmin();
  }

  ngOnInit() {
    this.hasWriteAccess = this._principal.isAdmin() ||
      (this._principal.hasWriteAccess(ModuleENUM.DICTIONARY) && this._principal.hasModuleExtendedEdit(ModuleENUM.DICTIONARY, ModuleExtendedEdit.DATA_EDIT));
    this.page = new PageDTO();
    this.page.sorting = {};
    this.page.filter = {
      text: ''
    };
    this.reloadList();
  }

  onEdit(id: number): void {
    this._dialog.closeAll();
    const dialogRef = this._dialog.open(CenterNationalityDialogComponent, {
      width: '900px',
      data: {
        type: 'CENTER_NATIONALITY',
        id: id
      }
    });
    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result) {
          this._utils.notifySuccess(this._translateService.instant('saved'), null);
          this.reloadList();
        }

      }
    );
  }

  reloadBySort(p, v) {
    if (!v && this.page.sorting[p]) {
      delete this.page.sorting[p];
    }
    if (v) {
      this.page.sorting[p] = v;
    }
    this.reloadList();
  }

  reloadList(resetPage?) {
    if (resetPage) {
      this.page.pageNumber = 0;
    }

    this._centerNationalityService.getList(this.page).subscribe(
      data => {
        this.page.totalElements = data.totalElements;
        this.centerNationalityList = data.dtoList;
        Language.updateListLocalizedName(this.centerNationalityList);
      }
    );
  }

  onLangChange(langCode): void {
    Language.updateListLocalizedName(this.centerNationalityList);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/user/components/dictionary/nationality/center-nationality.component.ts